import { Helmet } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// components
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import MyTaskList from './components/MyTaskList';
import BreadCrumb from '../../components/breadcrumb/BreadCrumbNavigation';
// ----------------------------------------------------------------------

export default function MyTaskPage() {
  const queryClient = new QueryClient();

  const breadcrumbs = [
    {
      label: 'Home',
      path: '/',
    },
    {
      label: 'My Task',
      path: '',
    },
  ];
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Helmet>
          <title> My Tasks </title>
        </Helmet>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <BreadCrumb breadcrumbs={breadcrumbs} />
          <MyTaskList />
        </LocalizationProvider>
      </QueryClientProvider>
    </>
  );
}
